// 菜单折叠事件
export const MENU_EX = "MENU_EX";

// 增加全局数据
export const ADD_GLOBAL_DATA = "ADD_GLOBAL_DATA";

// 行程检查信息更新
export const ROUTE_CHECK_INFO = "ROUTE_CHECK_INFO";

// 分流提示信息更新
export const SHUNT_TIP_INFOS = "SHUNT_TIP_INFOS";
